import React from 'react';
import { Button, ButtonPriority, ButtonSize, Avatar, AvatarSize, ActionsMenuLayout, HoverStyles, } from 'wix-ui-tpa/cssVars';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { useApi } from '../../api-provider';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import DropdownButton from '../dropdown-button/dropdown-button';
import { UserActionsSheetModal, useModal } from '../modals';
import { VerticallyPositionedContainer } from '../vertically-positioned-container/vertically-positioned-container';
import { classes } from './user-auth-control.st.css';
import { USER_AUTH_LOGOUT, USER_AUTH_LOGIN } from '../../../common/constants/data-hooks';
export const UserAuthControl = (props) => {
    const { requestLogin, requestLogout, isMobile } = useApi((state, actions) => ({
        requestLogin: actions.requestLogin,
        requestLogout: actions.requestLogout,
        isMobile: getIsMobile(state),
    }));
    const t = useTranslate();
    const showModal = useModal();
    const renderLogout = (avatarUrl) => isMobile ? (React.createElement("button", { onClick: () => showModal((toggle) => (React.createElement(UserActionsSheetModal, { toggle: toggle, logout: () => {
                requestLogout();
            } }))), "data-hook": USER_AUTH_LOGOUT },
        React.createElement(Avatar, { className: classes.avatar, src: avatarUrl, size: AvatarSize.small }))) : (React.createElement(DropdownButton, { className: classes.dropdownButton, buttonProps: {
            children: React.createElement(Avatar, { className: classes.avatar, src: avatarUrl, size: AvatarSize.small }),
            'data-hook': USER_AUTH_LOGOUT,
        } },
        React.createElement(VerticallyPositionedContainer, { className: classes.dropdownMenu, offset: 32 },
            React.createElement(ActionsMenuLayout, null,
                React.createElement(ActionsMenuLayout.Item, { content: t('user-actions.log-out'), onClick: () => {
                        requestLogout();
                    } })))));
    return (React.createElement("div", { className: classes.root }, props.state === 'login' ? (React.createElement(Button, { className: classes.loginBtn, priority: ButtonPriority.secondary, size: ButtonSize.tiny, onClick: () => {
            requestLogin({ mode: 'login' });
        }, upgrade: true, "data-hook": USER_AUTH_LOGIN, hoverStyle: HoverStyles.underline },
        React.createElement("span", { className: classes.text }, t('user-actions.log-in')))) : (renderLogout(props.avatarUrl))));
};
//# sourceMappingURL=user-auth-control.js.map